var _this = this;
import * as tslib_1 from "tslib";
import { onBackspacePressedSearchInput } from '../actions/internalActions';
import { getStore } from '../store/store';
import { lazyRemoveSuggestionPillFromSearchBox } from 'owa-search';
import { orchestrator } from 'satcheljs';
export default orchestrator(onBackspacePressedSearchInput, function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var searchStore, suggestionPillsCount, removeSuggestionPillFromSearchBox;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                searchStore = getStore();
                if (!(searchStore.searchText.length === 0)) return [3 /*break*/, 2];
                suggestionPillsCount = searchStore.suggestionPillIds.length;
                if (!(suggestionPillsCount > 0)) return [3 /*break*/, 2];
                return [4 /*yield*/, lazyRemoveSuggestionPillFromSearchBox.import()];
            case 1:
                removeSuggestionPillFromSearchBox = _a.sent();
                removeSuggestionPillFromSearchBox(searchStore.suggestionPillIds[suggestionPillsCount - 1]);
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); });
//# sourceMappingURL=onBackspacePressedSearchInput.js.map